import type { SVGAttributes } from 'react';
import { useId } from 'react';

import { unitMapping } from 'lib/style';

type Props = {
  size?: keyof typeof unitMapping;
  className?: string;
  color?: SVGAttributes<SVGPathElement>['fill'];
  gradient?: 'red' | 'green';
};

export const Box = ({
  size = 2,
  className,
  color = 'currentColor',
  gradient,
}: Props) => {
  const id = useId();
  let fill = color;
  if (gradient) {
    fill = `url(#box-gradient-${gradient}-${id})`;
  }

  return (
    <svg
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      className={className}
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.2803 7.41422L15.6051 3.25751L5.93373 7.41257L6.31366 7.5758L15.6089 11.5694L24.9042 7.5758L25.2803 7.41422ZM2.15769 5.79023L2.15768 5.77783L15.6051 0.000488281L29.0525 5.77782L29.0525 5.79353L29.0748 5.78393L29.078 10.3232L29.0802 13.3963L29.0816 15.3692L27.6102 16.0014L27.6102 16.0394L27.612 24.8452L15.6131 30.0002L3.6141 24.8452L3.61231 16.04L3.6123 16.0015L2.14336 15.3704L2.14198 13.4006L2.13983 10.3274L2.13666 5.78119L2.15769 5.79023ZM5.13237 10.3318L5.13451 13.3985L14.1143 17.2564V14.1906L5.13237 10.3318ZM6.6051 17.3258L14.1143 20.552V26.0993L6.60623 22.8737L6.6051 17.3258ZM17.1068 20.5521V26.1015L24.6191 22.874L24.6179 17.325L17.1068 20.5521ZM17.1068 14.1883V17.2569L26.0877 13.3985L26.0855 10.3309L17.1068 14.1883ZM14.7426 5.94476C14.1839 6.09096 13.5802 6.14398 12.9837 6.09907L12.9839 6.09955C12.9603 6.0979 12.9367 6.10076 12.9152 6.10766C12.8939 6.1144 12.8761 6.12535 12.8633 6.13872C12.8507 6.15193 12.8439 6.16741 12.8437 6.18338C12.8434 6.19936 12.8496 6.21486 12.8622 6.22843C13.1729 6.57251 13.354 6.96203 13.3895 7.36325C13.425 7.76446 13.3141 8.16526 13.0666 8.53113C13.0571 8.54548 13.0537 8.56161 13.0571 8.57743C13.0602 8.59308 13.0703 8.60795 13.0852 8.62024C13.1006 8.63253 13.1201 8.64176 13.1428 8.64696C13.1655 8.65216 13.1896 8.65317 13.2127 8.64966C13.7967 8.55885 14.4054 8.56441 14.9861 8.66594C15.5669 8.76747 16.1024 8.96203 16.5461 9.23259C16.5641 9.24311 16.5856 9.25009 16.6092 9.25303C16.6329 9.25598 16.6567 9.25424 16.6789 9.24847C16.7011 9.2427 16.7204 9.23305 16.7347 9.22033C16.7489 9.20761 16.7576 9.19245 16.7601 9.17664C16.8104 8.7759 17.0059 8.38961 17.3297 8.05098C17.6534 7.71234 18.0954 7.43152 18.6178 7.23314C18.6383 7.22527 18.6552 7.21368 18.6666 7.19966C18.678 7.18564 18.6833 7.16983 18.6819 7.15402C18.6805 7.1382 18.6723 7.12302 18.6586 7.10992C18.6448 7.09683 18.626 7.08679 18.6041 7.08046C18.0509 6.92412 17.5628 6.67994 17.1816 6.36931C16.8004 6.05867 16.5375 5.69079 16.4159 5.29734C16.4108 5.28135 16.3995 5.26665 16.3827 5.255C16.366 5.2432 16.3446 5.23493 16.321 5.23102C16.2973 5.2271 16.2725 5.22787 16.2496 5.23315C16.2267 5.23844 16.2064 5.24776 16.1912 5.26048C15.7986 5.56382 15.3014 5.79856 14.7426 5.94476Z"
        fill={fill}
      />
      <defs>
        <linearGradient
          id={`box-gradient-red-${id}`}
          x1="25.6605"
          y1="42.8839"
          x2="15.2856"
          y2="20.3792"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1FF00" />
          <stop offset="1" stopColor="#FF0974" />
        </linearGradient>
      </defs>
      <defs>
        <linearGradient
          id={`box-gradient-green-${id}`}
          x1="25.6605"
          y1="42.8839"
          x2="15.2856"
          y2="20.3792"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1FF00" />
          <stop offset="1" stopColor="#3DDC84" />
        </linearGradient>
      </defs>
    </svg>
  );
};
